// import React from "react";
// import instagram from "../assets/icons/instagram-bw.svg";
// import twitter from "../assets/icons/twitter-bw.svg";
// import linkedin from "../assets/icons/linkedin-bw.svg";
// import facebook from "../assets/icons/facebook-bw.svg";

// export const InfluencerFooter = () => {
//   const socialLinks = [
//     {
//       icon: instagram,
//       alt: "Social Media 1",
//       width: "21px",
//       height: "24px",
//       url: "https://www.instagram.com/hobo.video",
//     },
//     {
//       icon: twitter,
//       alt: "Social Media 2",
//       width: "24px",
//       height: "24px",
//       url: "https://twitter.com/hobo_video",
//     },
//     {
//       icon: linkedin,
//       alt: "Social Media 3",
//       width: "21px",
//       height: "24px",
//       url: "https://www.linkedin.com/company/hobo-video/",
//     },
//     {
//       icon: facebook,
//       alt: "Social Media 4",
//       width: "24px",
//       height: "24px",
//       url: "https://www.facebook.com/HoboVideoGlobal/",
//     },
//   ];

//   return (
//     <footer
//       className="bg-white flex flex-row justify-center w-full"
//       role="banner"
//     >
//       <div className="relative w-[1280px] h-[60px] border-0 border-none">
//         <div className="relative w-[1248px] h-[60px] left-4 border-0 border-none">
//           <div className="absolute w-[293px] h-[60px] top-0 left-0 border-0 border-none">
//             <h1 className="absolute w-[161px] top-2.5 left-7 [font-family:'Roboto-Medium',Helvetica] font-medium text-gray-900 text-sm tracking-[0] leading-[18px]">
//               Connect With Us
//             </h1>

//             <p className="absolute w-56 top-8 left-7 [font-family:'Roboto-Regular',Helvetica] font-normal text-gray-600 text-sm tracking-[0] leading-4 whitespace-nowrap">
//               Stay updated with latest campaigns
//             </p>
//           </div>

//           <div
//             className="absolute w-[162px] h-6 top-[18px] right-0 border-0 border-none"
//             role="navigation"
//             aria-label="Social media links"
//           >
//             {socialLinks.map((link, index) => {
//               const positions = [
//                 "left-1",
//                 "left-[43px]",
//                 "left-[89px]",
//                 "left-[132px]",
//               ];
//               const topPositions = ["-top-px", "-top-px", "top-0", "top-0"];
//               const containerWidths = ["w-[21px]", "w-6", "w-[23px]", "w-6"];

//               return (
//                 <a
//                   key={index}
//                   href={link.url}
//                   className={`flex ${containerWidths[index]} h-6 items-center justify-center absolute ${topPositions[index]} ${positions[index]}`}
//                   aria-label={link.alt}
//                 >
//                   <img
//                     className={`relative ${
//                       link.width === "21px" ? "w-[21px]" : "w-6"
//                     } h-6`}
//                     alt={link.alt}
//                     src={link.icon}
//                   />
//                 </a>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default InfluencerFooter;

import React from "react";
import instagram from "../assets/icons/instagram-bw.svg";
import twitter from "../assets/icons/twitter-bw.svg";
import linkedin from "../assets/icons/linkedin-bw.svg";
import facebook from "../assets/icons/facebook-bw.svg";

export const InfluencerFooter = () => {
  const socialLinks = [
    {
      icon: instagram,
      alt: "Instagram",
      url: "https://www.instagram.com/hobo.video",
    },
    {
      icon: twitter,
      alt: "Twitter",
      url: "https://twitter.com/hobo_video",
    },
    {
      icon: linkedin,
      alt: "LinkedIn",
      url: "https://www.linkedin.com/company/hobo-video/",
    },
    {
      icon: facebook,
      alt: "Facebook",
      url: "https://www.facebook.com/HoboVideoGlobal/",
    },
  ];

  return (
    <footer className="bg-white w-full font-poppins" role="contentinfo">
      <div className="mx-auto flex justify-between items-center px-[10px] lg:px-[90px] py-4">
        {/* Left text block */}
        <div>
          <h1 className="text-[12px] sm:text-sm font-medium text-gray-900">
            Connect With Us
          </h1>
          <p className="text-[10px] sm:text-sm text-gray-600 mt-1">
            Stay updated with latest campaigns
          </p>
        </div>

        {/* Right social links */}
        <nav
          className="flex items-center gap-4 sm:gap-5"
          aria-label="Social media links"
        >
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-4 sm:w-6 h-6 flex items-center justify-center"
              aria-label={link.alt}
            >
              <img
                src={link.icon}
                alt={link.alt}
                className="w-full h-full object-contain"
              />
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default InfluencerFooter;
